import { Site } from '@envato/foundation-types'

import React from 'react'
import classnames from 'classnames'

import styles from './index.module.css'

const GroupPanel = ({ children, currentSite, isSidebarOpen }) => {
  const toggleFilterContainerStyle = classnames(styles.filterGroupContainer, {
    [styles.showOnDesktop]: isSidebarOpen && currentSite !== Site.photodune,
    [styles.showOnMobile]: !isSidebarOpen && currentSite !== Site.photodune,
    [styles.alwaysShow]: isSidebarOpen && currentSite === Site.photodune,
    [styles.alwaysHide]: !isSidebarOpen && currentSite === Site.photodune
  })

  return (
    <div
      className={toggleFilterContainerStyle}
      aria-label={isSidebarOpen ? 'Collapse filter' : 'Expand filter'}
    >
      {children}
    </div>
  )
}

export default GroupPanel
